import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import type { ViewsService } from '@/engine/app/Views.service';
import { TYPES } from '@/engine/ioc';
import { inject, injectable } from 'inversify';
import { SetViewOptionVisibilityCommand } from './SetViewOptionVisibility.command';
import type { VisibilityLinkedVMController } from './VisibilityLinkedVMController';
import type { Transparency, ViewOption, ViewOptionsGroup } from '@/engine/app/interfaces';
import { SetViewOptionTransparencyCommand } from './SetViewOptionTransparency.command';
import { SetViewOptionContourVisibilityCommand } from './SetViewOptionContourVisibility.command';
import { SetGroupVisibilityCommand } from './SetGroupVisibility.command';
import { SetGroupTransparencyCommand } from './SetGroupTransparency.command';
import { SetGroupContourVisibilityCommand } from './SetGroupContourVisibility.command';

@injectable()
export class ViewOptionsCommandFactory {
  private readonly _viewsService: ViewsService;

  private readonly _visibilityLinkedVmController: VisibilityLinkedVMController;

  public constructor(
    @inject(TYPES.ViewsService) viewsService: ViewsService,
    @inject(TYPES.VisibilityLinkedVMController) visibilityLinkedVmController: VisibilityLinkedVMController
  ) {
    this._viewsService = viewsService;
    this._visibilityLinkedVmController = visibilityLinkedVmController;
  }

  public createSetViewOptionVisibilityCommand(viewOption: ViewOption, isVisible: boolean): ICommand {
    return new SetViewOptionVisibilityCommand(this._viewsService, this._visibilityLinkedVmController, viewOption, isVisible);
  }

  public createSetViewOptionTransparencyCommand(viewOption: ViewOption, transparency: Transparency): ICommand {
    return new SetViewOptionTransparencyCommand(this._viewsService, viewOption, transparency);
  }

  public createSetViewOptionContourVisibilityCommand(viewOption: ViewOption, isVisible: boolean): ICommand {
    return new SetViewOptionContourVisibilityCommand(this._viewsService, viewOption, isVisible);
  }

  public createSetGroupVisibilityCommand(viewOption: ViewOptionsGroup, isVisible: boolean): ICommand {
    return new SetGroupVisibilityCommand(this._viewsService, this._visibilityLinkedVmController, viewOption, isVisible);
  }

  public createSetGroupTransparencyCommand(viewOption: ViewOptionsGroup, transparency: Transparency): ICommand {
    return new SetGroupTransparencyCommand(this._viewsService, viewOption, transparency);
  }

  public createSetGroupContourVisibilityCommand(viewOption: ViewOptionsGroup, isVisible: boolean): ICommand {
    return new SetGroupContourVisibilityCommand(this._viewsService, viewOption, isVisible);
  }
}
